import React, { useState, useEffect } from "react";
import axios from "axios";
import "./CustomerDispatches.css"; // Reuse or adapt styles from OrderEntries.css
import { useAuth } from "../AuthContext";

const CustomerDispatches = () => {
  const [orders, setOrders] = useState([]);
  const { mobile } = useAuth();

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/dispatches/customer/${mobile}`
        );
        const sortedEntries = response.data.sort(
          (a, b) => new Date(b.id) - new Date(a.id)
        );
        setOrders(sortedEntries);
      } catch (error) {
        console.error("Failed to fetch orders", error);
      }
    };

    if (mobile) {
      fetchOrders();
    }
  }, [mobile]);

  const formatDate = (dateString) => {
    if (!dateString) return ""; // Return empty string if date is null
    const date = new Date(dateString);
    const pad = (num) => num.toString().padStart(2, "0");
    return `${pad(date.getDate())}/${pad(
      date.getMonth() + 1
    )}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };

  const getRowStyle = (order) => {
    if (!order.order_packed_by && !order.dispatch_status) {
      // Light red color for orders not packed and not dispatched
      return { backgroundColor: "#ffcccc" };
    } else if (order.order_packed_by && !order.dispatch_status) {
      // Light yellow color for orders packed but not dispatched
      return { backgroundColor: "#ffffcc" };
    } else if (order.order_packed_by && order.dispatch_status) {
      // Light green color for orders packed and dispatched
      return { backgroundColor: "#ccffcc" };
    } else {
      // Default styling (could be empty or another color)
      return {};
    }
  };

  return (
    <div className="order-status-page">
      <h2>Your Dispatches</h2>
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Party Name</th>
              <th>Invoice Number</th>
              <th>Date of Dispatch</th>
              <th>Mode</th>
              <th>Transport / Courier Name</th>
              <th>Docket / GR</th>
              <th>Value</th>
              <th>No. of Cases</th>
              <th>Image of Builty</th>
            </tr>
          </thead>
          <tbody>
            {orders.length > 0 ? (
              orders.map((order) => (
                <tr key={order.id}>
                  <td>{order.party_name}</td>
                  <td>{order.invoice}</td>
                  <td>{formatDate(order.date_of_dispatch)}</td>
                  <td>{order.mode_of_transport}</td>
                  <td>{order.transport_courier_name}</td>
                  <td>{order.docket_gr_no}</td>
                  <td>{order.value_of_goods}/-</td>
                  <td>{order.no_of_cases}</td>
                  <td style={{ textAlign: "center" }}>
                    {order.image_of_builty ? (
                      <a
                        href={
                          "https://www.trumachealthcare.net/apiwha/dispatch-builtys/" +
                          order.image_of_builty
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Image
                      </a>
                    ) : (
                      "No Image"
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6">No orders found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CustomerDispatches;
